import { useEffect } from "react";
import { useMsalAuth } from "../hooks/use-msal-auth";

export function LogoutPage() {
  const { logout } = useMsalAuth();

  useEffect(() => {
    logout();
  }, []);

  return (
    <div style={{ display: "flex", padding: "50px", justifyContent: "center" }}>
      <h3>Logging out...</h3>
    </div>
  );
}
